var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileGrid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.5 14v2.5H0V14zm7 0v2.5H7V14zm7 0v2.5H14V14zm-14-7v2.5H0V7zm7 0v2.5H7V7zm7 0v2.5H14V7zm-14-7v2.5H0V0zm7 0v2.5H7V0zm7 0v2.5H14V0z"
})));
export default SvgInstagramMobileGrid;